import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import 'jquery-confirm';

export default function Rewards(props) {
    if (!props.penalistData.hasOwnProperty('data') || props.penalistData.data === null) return <></>;
    const { rewards } = props.penalistData.data;
    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Rewards</h4>
                </div>
            </CardHeader>
            <CardBody>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={4}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Earned By Survey : <br />{rewards.earnedBySurvey}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Earned By Referrals : <br />{rewards.earnedByReferrals}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Total Earned : <br />{rewards.totalPoints}
                        </Paper>
                    </Grid>
                </Grid>
            </CardBody>
        </Card>
    )
}